import { Component, OnInit } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { GlobalserviceService } from '../globalservice.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-adminmap',
  templateUrl: './adminmap.component.html',
  styleUrls: ['./adminmap.component.css']
})
export class AdminmapComponent implements OnInit {
  lat: number; lng: number;

  public radius;
  latitude: number;
  longitude: number;
  data1: number;
  data2: number;
  meth = {};
  zoom;
  public markers;
  filteredMarkers = [];
  allUsers: any;
  desc: any;
  first: number;
  secound: number;
  public obj = []; infoWindowOpened = null;
  current_loc: any;

  CurrentRadius: any;
  radiusLocation: any;
  Zone: any;

  constructor(private mapsAPILoader: MapsAPILoader,public snackBar: MatSnackBar, public globalservice: GlobalserviceService, ) { }

  ngOnInit() {
    this.lat =parseFloat(sessionStorage.LatLogin);
    this.lng =parseFloat(sessionStorage.LongLogin);
    this.zoom = 5;
    this.checkinUSers();

    this.radiusLocation = sessionStorage.signinlocation;
    console.log(this.obj);debugger;
    this.Zone = '';
   }
  livemap(data,zone) {

    console.log(data);
    console.log(zone);debugger
    if(data==undefined){
      this.snackBar.open('Please select Radius(KM)', '', { duration: 3000 });
    }else{
    this.meth = parseInt(data);
    console.log(this.meth); debugger;
    this.lat = parseFloat(sessionStorage.latitude);
    this.lng = parseFloat(sessionStorage.longitude);
    this.latitude = parseFloat(sessionStorage.latitude);
    this.longitude = parseFloat(sessionStorage.longitude);
    this.zoom = 12;
   }
//
// var rad_zone = {
//   "Location": zone,
//   "radius": data
// }

// console.log(rad_zone);debugger;

// this.globalservice.allmap_details(rad_zone).subscribe(responsedata => {
//   this.globalservice.disableloader();
//     if (responsedata.Success) {
//       this.allUsers = responsedata['Data'];
//       console.log(this.allUsers);
//      }
//   },
//     err => {
//       this.globalservice.disableloader();
//       alert("Network Error");
//     });

//

  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  keyPresss(event: any) {
    const pattern = /^[a-zA-Z]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  checkinUSers() {
      // new changes
 //sessionStorage.setItem("radius", "0");
// console.log(sessionStorage);debugger;
if (this.radius !== undefined) {this.radius = this.meth; } else {this.radius = '9000' ; }

   var level = {
      "Location": sessionStorage.signinlocation,
      "radius": this.radius
    }
   console.log(level);
    debugger;
    this.globalservice.enableloader();
    debugger;
    this.globalservice.allmap_details(level).subscribe(responsedata => {
    this.globalservice.disableloader();
    // console.log(this.obj);debugger;
      if (responsedata.Success) {
        this.allUsers = responsedata['Data'];
        // console.log(this.allUsers);debugger;
        // console.log(this.obj);debugger;
        this.obj=[];
       for (var i = 0; i < this.allUsers.length; i++) {
          this.obj.push({
            "currentlat": parseFloat(this.allUsers[i].OD_START_LOCATION_LAT),
            "currentlng": parseFloat(this.allUsers[i].OD_START_LOCATION_LONG),
            "OD_start": this.allUsers[i].OD_START_TIME,
            "OD_startloct": this.allUsers[i].OD_START_LOCATION_NAME,
            "OD_endName": this.allUsers[i].OD_END_LOCATION_NAME,
            "OD_endTime": this.allUsers[i].OD_END_TIME,
            "EmpID": this.allUsers[i].EMP_ID,
            "Emp_Name": this.allUsers[i].NAME,
            "Emp_Desig": this.allUsers[i].DESIGNATION,
            "Emp_Dep": this.allUsers[i].DEPARTMENT,
           });
        }
        // console.log(this.obj);debugger;
       }
       else{
        this.obj=[];
       }
    },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });
  }
  clickedMarker(infoWindow, index: number) {
   if (this.infoWindowOpened === infoWindow)
      return;
    if (this.infoWindowOpened !== null)
      this.infoWindowOpened.close();
      this.infoWindowOpened = infoWindow;
  }
  Radius = [
    { value: '1', viewValue: '5000'},
    { value: '2', viewValue: '6000'},
    { value: '3', viewValue: '7000'},
    { value: '4', viewValue: '8000'},
    { value: '5', viewValue: '9000'},
 ]
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
